import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { FrontlineUser } from '@models/Commission';

export type SearchFrontlineUsersParams = {
  search?: string;
};

export class FrontlineUserApi {
  static search = async (params: SearchFrontlineUsersParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/frontline_users`, { params })
      .then((response) => humps(response.data) as FrontlineUser[]);
  };
}
